export const ServiceBlock = ({ service, onClick, active }) => {
    const blockStyle = active ? { backgroundColor: '#181c30', color: '#fff' } : {};

    return (
        <div className="serv-blk" onClick={() => onClick(service)} style={blockStyle}>
            <p>{service}</p>
        </div>
    );
}